import styled from 'styled-components'

const StyledLessonMapGroup = styled.details`
  font-family: ${({ theme }) => theme.fonts.nunito};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};

  summary {
    user-select: none;
    display: flex;
    align-items: center;
    padding: 20px 25px;
    min-height: 74px;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.colors.gray[100]};
    transition: 0.2s;

    .module-details {
      display: grid;
      row-gap: 4px;

      .module-title {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.gray[700]};
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-right: 25px;
      }

      .module-length {
        font-size: 14px;
        letter-spacing: 0.01rem;
        color: ${({ theme }) => theme.colors.gray[500]};
      }

      & + div {
        flex-shrink: 0;
      }
    }

    .module-completed {
      font-size: 14px;
      letter-spacing: 0.01rem;
      color: ${({ theme }) => theme.colors.gray[500]};
      margin-right: 16px;
    }

    svg {
      height: 20px;
      color: ${({ theme }) => theme.colors.gray[400]};
    }

    ::-webkit-details-marker {
      display:none;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .lesson-list {
    background-color: ${({ theme }) => theme.colors.background};
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  &[open] {
    .module-chevron-icon {
      transform: rotate(180deg);
    }
  }
`

export default StyledLessonMapGroup
